/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import {getSelectedProductIdFromActionInput, generateProductImageUrl } from '@msdyn365-commerce-modules/retail-actions';
import { ProductSearchResult, ProductSearchCriteria, ProductLookupClause } from '@msdyn365-commerce/retail-proxy';
// import {getByIdAsync, searchByCriteriaAsync} from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
 import {getRelatedProductsAsync} from './getRelatedProductDetails';
 import { searchByCriteriaAsync} from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';

/**
 * GetCustomProductSpec Input Action
 */
export class GetCustomRelatedProductsInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public productId: number;

    public channelId: number;

    public config: any;

    constructor(productId: number, channelId: number, config: any) {
        this.channelId = channelId;
        this.productId = productId;
        this.config = config;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GetCustomRelatedProducts${this.productId}`;
    public getCacheObjectType = () => 'RelatedProducts';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetCustomRelatedProductsData {
    text: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (inputData: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const productId = getSelectedProductIdFromActionInput(inputData);
    if(productId)
    {
        return new GetCustomRelatedProductsInput(+productId, +inputData.requestContext.apiSettings.channelId, inputData.config);

    }
    throw new Error('Unable to create SelectedVariantInput, no productId found on module config or query');
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetCustomRelatedProductsInput, ctx: Msdyn365.IActionContext): Promise<ProductSearchResult[]> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IGetCustomProductSpecData[]>('/get/example/id/1', 'get');
    let prodAttr:ProductSearchResult[] = new Array();
    //  const response = await getProductSpecificationDetailsAsync({callerContext: ctx},input.productId);
    // if(response && response.length > 0)
    // {
    //     response.forEach(element =>{
    //         let attr:AttributeValue={AttributeValueId:element.Specification_Id?+element.Specification_Id:0,
    //                                     KeyName:element.Public_Display_Name,
    //                                 Name:element.Public_Display_Name,
    //                             TextValue:element.Product_Attirbute_Value
    //                             ,DataTypeValue: 5 };
    //         prodAttr.push(attr);
    //     });
    // }
    const response = await getRelatedProductsAsync({callerContext: ctx},input.productId);
    if(response && response.length > 0)
    {
        const productLookup:ProductLookupClause[] = new Array();
        response.forEach(function(itemids,index){
            const prodLookup:ProductLookupClause = {
                ItemId : itemids.ItemId};
                productLookup.push(prodLookup);
        });
        const criteria:ProductSearchCriteria={
            Context:{CatalogId:ctx.requestContext.apiSettings.catalogId,ChannelId:ctx.requestContext.apiSettings.channelId},
            ItemIds:productLookup
        };
        var prodLists = await searchByCriteriaAsync({callerContext: ctx},criteria);


        if(prodLists.length > 0 )
          {
             const prodLst = prodLists.map(productSearchResult => {
                let newImageUrl = generateProductImageUrl(
                    productSearchResult,
                    ctx.requestContext.apiSettings
                );
                 //const newImageUrl = productSearchResult.PrimaryImageUrl && productSearchResult.PrimaryImageUrl.search('&w=275&h=275&q=80&m=6&f=jpg') == -1 ? productSearchResult.PrimaryImageUrl + '&w=275&h=275&q=80&m=6&f=jpg' : productSearchResult.PrimaryImageUrl
                if (newImageUrl) {
                    newImageUrl = decodeURI(newImageUrl);
                    // console.log(newImageUrl);
                    productSearchResult.PrimaryImageUrl = newImageUrl;
                }
                console.log(productSearchResult.PrimaryImageUrl);
                return (productSearchResult);
            });
            prodAttr = prodLst;
        }
    }
    return  prodAttr;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ProductSearchResult[]>>action,
    // TODO: Give your data action a unique id
    id: 'GetRelatedProductDetails',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
